import script from "./PageLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLoading.vue?vue&type=script&setup=true&lang=js"

import "./PageLoading.vue?vue&type=style&index=0&id=63816b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63816b82"]])

export default __exports__